<div class="wetter_content_container">
  <div class="bericht-text-container">
    <h3>Heute</h3>
    {{videotextVorhersageBericht?.vorhersageHeute}}
  </div>
  <div class="bericht-text-container">
    <h3>Kommende Nacht</h3>
    {{videotextVorhersageBericht?.vorhersageKommendeNacht}}
  </div>
  <div class="bericht-text-container">
    <h3>Aussichten</h3>
    <ng-container *ngFor="let aussichtTag of videotextVorhersageBericht?.aussichten?.aussichtsListe">
      <span class="bericht-text-sub-label">{{aussichtTag.datum | date: 'EEE dd.MM'}}</span>
      {{aussichtTag.text}}
    </ng-container>
  </div>
  <div class="bericht-text-container">
    <h3>Regenradar</h3>

    {{videotextVorhersageBericht?.regenradar}}
  </div>
  <div class="bericht-text-container">
    <h3>Pollenflug</h3>
    {{videotextVorhersageBericht?.pollenflug}}
  </div>
  <div class="bericht-text-container">
    <h3>Spezialwetter</h3>
    {{videotextVorhersageBericht?.spezialWetter?.absatz1}}
    {{videotextVorhersageBericht?.spezialWetter?.absatz2}}
  </div>
</div>
